import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HubspotTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window._hsq) {
      window._hsq.push(["setPath", location.pathname + location.search]);
      window._hsq.push(["trackPageView"]);
    }
  }, [location]);

  return null;
};

export default HubspotTracker;
